import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBoolean, FctBytes32 } from '../../../../Fct/generics';
import { supportedContracts } from '../constants';
export var ValidateSignature = createPlugin({
    protocol: 'SingersValidator',
    type: 'GETTER',
    method: 'validateSignature',
    supportedContracts: supportedContracts,
    falseMeansFail: true,
    getParams: function (_a) { return ({
        input: {
            to: new FctAddress({}),
            methodParams: {
                messageHash: new FctBytes32({}),
                valuesHash: new FctBytes32({}),
                signer: new FctAddress({}),
                r: new FctBytes32({}),
                sv: new FctBytes32({}),
            },
        },
        output: {
            result: new FctBoolean({}),
        },
    }); },
    initParams: {
        methodParams: {
            messageHash: { type: 'global', id: 'flowHash' },
        }
    }
});
